module.exports = __webpack_public_path__ + "static/img/fidhail.3a82770.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/fidhail.png
// module id = THK3
// module chunks = 0